import { Link } from 'react-router-dom';
import { Calendar, Cloud, BookOpen, Image, Users } from 'lucide-react';
import logo from '../assets/RykenLabsLogo.png';

function Footer() {
  return (
    <footer className="bg-sky-50 py-12 border-t border-sky-200">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Column 1: Logo and description */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img src={logo} alt="Ryken Labs" className="w-8 h-8" />
              <h2 className="text-2xl font-bold glow-text">Ryken Labs</h2>
            </div>
            <p className="text-slate-600 mb-4">
              Your family's complete information center - weather, calendar, activities, and more on a single screen.
            </p>
            <div className="flex space-x-4 mb-4" style={{ color: 'var(--ryken-primary)' }}>
              <Calendar size={20} />
              <Cloud size={20} />
              <BookOpen size={20} />
              <Image size={20} />
              <Users size={20} />
            </div>
            <p className="text-slate-500">
              © {new Date().getFullYear()} Ryken Labs, LLC. All rights reserved.
            </p>
          </div>
          
          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ color: 'var(--ryken-accent)' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-600 hover:opacity-80 transition-opacity duration-200">Home</Link>
              </li>
              <li>
                <Link to="/features" className="text-slate-600 hover:opacity-80 transition-opacity duration-200">Features</Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-600 hover:opacity-80 transition-opacity duration-200">About</Link>
              </li>
            </ul>
          </div>
          
          {/* Column 3: Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ color: 'var(--ryken-accent)' }}>Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-slate-600 hover:opacity-80 transition-opacity duration-200">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-600 hover:opacity-80 transition-opacity duration-200">Terms of Service</Link>
              </li>
            </ul>
            
            <div className="mt-6">
              <h3 className="text-lg font-semibold mb-4" style={{ color: 'var(--ryken-accent)' }}>Contact</h3>
              <p className="text-slate-600">info@rykenlabs.com</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;